import { getMarketCurrencies } from "./market";

export const updateMarketPageTitle = (marketName: string, formattedPrice?: string) => {
  const primaryCurrency = getMarketCurrencies(marketName).primaryCurrency;

  let title = `${primaryCurrency} | Decibel`;

  // Setting Market name only, No Price, this shouldn't overwrite if market name is already included
  if (!formattedPrice) {
    const titleAlreadyIncludesMarketName = document.title.includes(primaryCurrency);
    if (!titleAlreadyIncludesMarketName) {
      document.title = title;
    }
    return;
  }

  title = `${formattedPrice} | ${title}`;
  document.title = title;
};
